<template>
    <section class="background-section" style="background-color: #F3EFF0;">
      <!-- Nueva imagen superior centrada -->
      <img class="top-center-image" src="../assets/periogard/Saludable.png" alt="Imagen superior centrada">
  
      <!-- Contenedor principal con la imagen base y la imagen centrada -->
      <div class="image-container">
        <img class="base-image" src="../assets/periogard/basefondo.png" alt="Imagen base">
        <img class="overlay-image" src="../assets/periogard/Sueño.png" alt="Imagen sobrepuesta">
        <img class="extra-overlay-image" src="../assets/periogard/Remocion.png" alt="Imagen extra centrada">
      </div>
  
      <!-- Imágenes de las esquinas (fuera de image-container) -->
      <img class="corner-image top-left" src="../assets/periogard/Texto 3.png" alt="Esquina superior izquierda">
      <img class="corner-image top-right" src="../assets/periogard/Texto 4.png" alt="Esquina superior derecha">
      <img class="corner-image bottom-left" src="../assets/periogard/Texto 5.png" alt="Esquina inferior izquierda">
      <img class="corner-image bottom-right" src="../assets/periogard/Texto 6.png" alt="Esquina inferior derecha">
  
      <!-- Texto pequeño centrado abajo tocando el borde inferior -->
      <p class="bottom-text">Duque Duque A, Chaparro Padilla A, Almeida ML, Marín Jaramillo RA, Romanelli HJ, Lafaurie Villamil GI. Strategies for the prevention of periodontal disease and its impact on general health: Latin America and the Caribbean Consensus 2024. Braz Oral Res. 2024 Oct;38(suppl 1):e120.</p>
    </section>
  </template>
  
  <script setup>
  import { onMounted } from "vue";
  import gsap from "gsap";
  import { ScrollTrigger } from "gsap/ScrollTrigger";
  import { MotionPathPlugin } from "gsap/MotionPathPlugin";
  
  gsap.registerPlugin(ScrollTrigger, MotionPathPlugin);
  
  onMounted(() => {
    const images = [
      { selector: ".top-center-image", path: [{ y: 0 }, { y: 300 }] },
      { selector: ".overlay-image", path: [{ y: 0 }, { y: 400 }] },
      { selector: ".extra-overlay-image", startY: -400, endY: 344.66 }, // Ajuste para Remocion.png
    ];
  
    images.forEach((image) => {
      if (image.startY !== undefined) {
        gsap.set(image.selector, { y: image.startY }); // Posiciona más arriba inicialmente
  
        gsap.to(image.selector, {
          y: image.endY, // Se mueve hasta este punto
          ease: "none",
          duration: 2.5,
          scrollTrigger: {
            trigger: image.selector,
            start: "top bottom",
            end: `+=${image.endY - image.startY}`, // Calcula la distancia hasta que se detiene
            scrub: 1,
          },
        });
      } else {
        // Para las otras imágenes que no necesitan ajuste
        gsap.to(image.selector, {
          motionPath: {
            path: image.path,
            autoRotate: false,
          },
          ease: "none",
          duration: 2.5,
          scrollTrigger: {
            trigger: image.selector,
            start: "top bottom",
            end: "bottom top",
            scrub: 1,
          },
        });
      }
    });
  });
  
  </script>
  
  <style scoped>
  .background-section {
    width: 100%;
    height: 130vh;
    background-image: url('../assets/periogard/Fondo_2.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    overflow: hidden;
  }
  
  /* Nueva imagen superior centrada */
  .top-center-image {
    position: absolute;
    top: -27%;
    left: 50%;
    transform: translateX(-50%);
    width: 30%;
    height: auto;
    object-fit: contain;
    z-index: 1;
  }
  
  .image-container {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1vh;
    box-sizing: border-box;
  }
  
  .base-image {
    width: 100%;
    height: 100%;
    object-fit: contain;
    z-index: 0;
  }
  
  .overlay-image {
    position: absolute;
    width: 50%;
    height: auto;
    object-fit: contain;
    z-index: 1;
    top: -11%;
  }
  
  /* Nueva imagen encima de las anteriores (extra) */
  .extra-overlay-image {
    position: absolute;
    width: 40%;
    height: auto;
    object-fit: contain;
    top: 26%;
    z-index: 2;
  }
  
  /* Imágenes de las esquinas */
  .corner-image {
    position: absolute;
    width: 25%;
    height: auto;
    object-fit: contain;
    z-index: 10;
  }
  
  /* Posicionamiento de las esquinas */
  .top-left {
    top: 3%;
    left: 17%;
  }
  
  .top-right {
    top: 17%;
    right: 11%;
  }
  
  .bottom-left {
    bottom: 44%;
    left: 6%;
  }
  
  .bottom-right {
    bottom: 24%;
    right: 6%;
  }
  
  /* Texto pequeño al fondo centrado */
  .bottom-text {
    position: absolute;
    font-family: 'ColgateReady-Italic';
    font-style: italic;
    text-align: center;
    width: 80%;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    font-size: 12px;
    color: gray;
    margin: 0;
    padding: 30px 0;
  }
  </style>
  